export const ONLINE_STORE = 'ONLINE_STORE';